import React, { PureComponent } from "react";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import "./styles.css";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import XLSX from "xlsx";
import { MDBDataTable } from "mdbreact";
import * as FileSaver from "file-saver";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from "../../../Common/util";
import API from "../../../Common/api";

import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";
import DatePicker from "react-datepicker";
import { PostAddTwoTone } from "@material-ui/icons";
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import exportToCSV from '../../../Common/exportcsv';
import DarkBackground from '../../../Common/backgroundLoader';
import Overlay from '../../../Common/overlay';
import EmptyDataIcon from '../../../../images/empty_data_icon.png'
import DownloadIcon from '../../../../images/download_icon.svg'



var url = window.location.hostname;
var port = window.location.port;
const Heading = [['Sr No.', 'Trip Id',  'sku7_code',  'Product Name', 'upc',  'MRP',  'Free Loose ','Free Cld', 'Loose To Be Picked', 'Cld To Be Picked', 'Dispatched Loose', 'Dispatched cld qty']];



class HorizontalForm extends PureComponent {
  
  constructor() {
    super();
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.fetchInventoryData = this.fetchInventoryData.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);

    this.state = {
      filtered_orderData : [],
      loading_overlay: false,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      fileNameVal: "masterFile",
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      loading: false,

      isLoading: true,
      showFetchBinData: true,
      show_process_data: true,

      // from_date: "",
      // to_date: "",

      tableRows: [],
      value: "",
      error: "",
      value: "select",
      selectedFileType: "",
      selectedSubGroup: "",
    };
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    // this.fetchInventoryData();
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie("token");
    var location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location,
    });

    localStorage.setItem("userName", username);
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }


  handleSubGroupChange = (e) => {
    const value = e.target.value;
    this.setState({
      selectedSubGroup: value,
    });
  };

  fetchInventoryData() {
    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
      loading_overlay: true,
    });

    const payload = {
      location: this.state.selectedLocation,

      request_type: "view",
      
      sub_group_id: this.state.selectedSubGroup,
      screen_type: "cld_dispatch_report",
    };
    addAnalytics('Report', 'View CLD Dispatch Report', payload);
    API.post("/download/cld-picksheet-report/", { param: payload })
      .then((response) => response.data)

      .then((data) => {
        
        // this.setState({ posts: data.data ,filtered_orderData : data.data});
        this.setState({tableRows: this.assemblePosts(data.data),})
      })

      .then(async () => {
        this.setState({  isLoading: false });

        console.log(this.state.tableRows);
      });
  }
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.posts});
    } else {
      
      var value = this.state.posts.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );
      
        this.setState({
          filtered_orderData: value,
        });
      }
    };
    
  downloadReport = () => {
    //this.setState({loading:true})
    const payload = {
      location: this.state.selectedLocation,

      request_type: "download",
      
      sub_group_id: this.state.selectedSubGroup,

      screen_type: "cld_dispatch_report",
    };

    API.post("/download/cld-picksheet-report/", { param: payload })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          loading: false,
        });

        window.location.href = data.data;
      })
      .catch(function (error) {});
  };

  assemblePosts = (data) => {
    let posts = data.map((post) => {
      var status = "";
      if (post.status == true) {
      status = "Active";
      } else { status = " Not Active" }
      return {
        sr_no : post.s_no,
        trip_id :post.trip_id,
        sku7_code: post.sku7_code,
        product_name : post.prod_name,
        upc: post.upc,
        mrp: post.mrp,
        free_loose : post.free_loose,
        free_cld : post.free_cld,
        loose_to_be_picked: post.loose_to_be_picked,
        // free_product: post.free_product,
        
        to_be_picked_icld_qty:post.to_be_picked_icld_qty,
        dispatched_loose : post.dispatched_loose,
        
        dispatch_cld : post.dispatched_cld,
        
      };
    });

    this.setState({
      loading_overlay: false,
      filtered_orderData : posts,
      posts : posts,
    });

    return posts;
  };

  processData() {
    this.setState({
      loading: true,
    });
  }

  render() {
    console.log(this.state.showInvalidItem);

    const data = {
      columns: [
        {label: "Sr No.",
        field: "sr_no",
        sort: "asc",
        width: 70
      },
        {
          label: "Trip Id",
        field: "trip_id",
        sort: "asc",
        width: 100
      },
      {
        label: "sku7_code",
        field: "sku7_code",
        width: 120,
        sort: "asc",
      },
      {
        label: "Product Name",
        field: "product_name",
        width: 150,
        sort: "asc",
      },
      {
        label: "upc",
        field: "upc",
        width: 120,
        sort: "asc",
      },
      {
        label: "MRP",
        field: "mrp",
        width: 110,
        sort: "asc",
      },
      {
        label: "Free Loose",
        field: "free_loose",
        width: 110,
        sort: "asc",
      },
      {
        label: "Free Cld",
        field: "free_cld",
        width: 110,
        sort: "asc",
      },
      {
        label: "Loose To Be Picked",
        field: "loose_to_be_picked",
        width: 110,
        sort: "asc",
      },
      {
        label: "Cld To Be Picked",
        field: "to_be_picked_icld_qty",
        width: 110,
        sort: "asc",
      },
      {
      label : "Dispatched Loose",
      field : "dispatched_loose",
      width: 120,
      sort : "asc"

      },

      {
        label : "Dispatched cld qty",
      field : "dispatch_cld",
      width: 120,
      sort : "asc"

      },
     
      ],

      rows: this.state.tableRows,
    };
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            ></LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          <Overlay>
            <form className="form">
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                <span className="filter_title">Filters</span>
              </div>

              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title">Sub Group</span>
                <div style={{ position: 'relative' }}>   
                   <input type = "text" style={{height: 38}} className="form-control" placeholder= "Sub Group Id " onChange={this.handleSubGroupChange}/>
                </div>
              </div>

              <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable1 "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_view"
                    onClick={() => this.fetchInventoryData()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View
                  </Button>

                  <Button
                    type="button"
                    className="btn btn-primary-outline"
                    style={{
                        cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                        backgroundColor: '#FFFFFF',
                        color: '#333333', // Set text color
                        display: 'flex',   // Use flexbox to align image and text
                        alignItems: 'center' // Center items vertically
                    }}
                    id="button_download"
                    onClick={(e) => exportToCSV(this.state.filtered_orderData, "CLD Dispatch Report", Heading)}
                    >
                    <img
                        src={DownloadIcon}
                        alt="Download"
                        style={{ width: '22px' }} // Adjust size as needed
                    />
                    Download
                  </Button>
                </ButtonToolbar>
              </div>
            </form>
          </Overlay>

           {!this.state.showFetchBinData && (
            <div style={{width: '80%', textAlign: 'center', padding: '12%'}}>
               <img style={{width: '10%'}} src={EmptyDataIcon} />
                <p className="noDataTextStyle">
                Choose your filters from the available options. The data will display
              </p>
              <p className="noDataTextStyle2">
                 here once the filters have been applied.
              </p>
            </div>
          )}
          {this.state.showFetchBinData && (
            <div>
              <div>

                {this.state.selectedSubGroup &&
                  <div className="date-container">
                   {this.state.selectedSubGroup}
                  </div>
                } 

              </div>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              <div style={{ marginTop: '4%', paddingTop: 20, paddingBottom: 0 }}>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              
                <div
                  className="dispatchData stock_check_data"
                  style={{ marginTop: -27 }}
                >
                  <MDBDataTable
                    striped
                    bordered
                    scrollX
                    onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'CLD Dispatch  Report', 'datatable_pagination_change' )}
                    sortable={false}
                    hover
                    onSearch={this.filterData}
                    data={data}
                    // style={{ textAlign: "center" }}
                  />
                </div>
              </div>
            </div>
          )}
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
